import FtService from "../../service/FtService";
// import this.$swal from 'sweetalert'
// import Swal from 'sweetalert2';

//export const namespaced = true

export const state = {
    batches: [],
    users: [],
    companies: [],
    tranSummary: [],
    formatter: new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "NGN"
    }),
    batchcard: [
        {
            name: 'Total Outflow',
            number: 'NGN 0.00',
            color: 'bg-gray-500'
        },
        {
            name: 'Total Count',
            number: '0',
            color: 'bg-indigo'

        },
        {
            name: 'Date Processed',
            number: '0%',
            color: 'bg-success'

        },
        {
            name: 'Status',
            number: '0',
            color: 'bg-black-6'
        }

    ],
    supportloading: false,
    batchloading: false,
    companyloading: false,
    userloading: false


};


export const getters = {
    totalAmount : state => state.formatter.format(
        state.batches.reduce(
            (acc, batch) =>  acc + batch.totalamount, 0.0)
    ),

};


export const mutations = {


    UPDATE_USERS: (state, payload) => {
            // console.log('Entered Mutation', payload);
            // console.log(payload);
            state.users = payload
    },

    UPDATE_BATCHES: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.batches = payload
    },

    UPDATE_COMPANIES: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.companies = payload
    },

    UPDATE_BATCH_LOADING: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.batchloading = payload
    },
    UPDATE_SUPPORT_LOADING: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.supportloading = payload
    },

    UPDATE_COMPANY_LOADING: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.companyloading = payload
    },


    UPDATE_USER_LOADING: (state, payload) => {
        // console.log('Entered Mutation', payload);
        state.userloading = payload
    },

    updateCards: (state, payload) => {
        //console.log('Entered Mutation', payload);
        state.cards = payload
    }


};


export const actions = {
    readAllBatches: ({commit}) => {
        // console.log('in batches action');
        if (state.batches.length < 1)
            commit("UPDATE_BATCH_LOADING", true);
        return FtService.getAllBatches().then(response => {
            let responseData = response.data;
            commit("UPDATE_BATCH_LOADING", false);
            if (responseData.responsecode === "00")
                commit("UPDATE_BATCHES", responseData.data);
            return responseData;
        }).catch(error => {
            commit("UPDATE_BATCH_LOADING", false);
            console.log(error)
        })
    },

    readAllUsers: ({commit}) => {
        // console.log('in batches action');
        if (state.users.length < 1)
            commit("UPDATE_USER_LOADING", true);
        return FtService.getAllUsers().then(response => {
            let responseData = response.data;
            commit("UPDATE_USER_LOADING", false);
            if (responseData.responsecode === "00")
                commit("UPDATE_USERS", responseData.data);
            return responseData;
        }).catch(error => {
            commit("UPDATE_USER_LOADING", false);
            console.log(error)
        })
    },

    submitSupportIssues: ({commit}, payload) => {
        commit("UPDATE_SUPPORT_LOADING", true);
        return FtService.submitSupportForm(payload).then(
            response => {
                commit("UPDATE_SUPPORT_LOADING", false)
                return response.data;
            }
        ).catch(
            err => {
                commit("UPDATE_USER_LOADING", false)
                console.log(err.message)
            }
        )
    },

    readAllCompanies: ({commit}) => {
        // console.log('in batches action');
        if (state.companies.length < 1)
            commit("UPDATE_COMPANY_LOADING", true);
        return FtService.getAllCompanies().then(response => {
            let responseData = response.data;
            commit("UPDATE_COMPANY_LOADING", false);
            if (responseData.responsecode === "00")
                commit("UPDATE_COMPANIES", responseData.data);
            return responseData;
        }).catch(error => {
            commit("UPDATE_COMPANY_LOADING", false);
            console.log(error)
        })
    },
}
